import React, { useEffect, useState } from 'react';
import { useRates } from '../code/Rates';

const Transacts = () => {
  const { selectedCurrency, convertBalance } = useRates();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTransactions = async () => {
      const token = localStorage.getItem('accessToken');

      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/account/transactions`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          if (response.status === 404) {
            const data = await response.json();
            if (data.message === "No transactions found for this user!") {
              setError('No transaction has been done yet. Try Deposit!');
            } else {
              throw new Error('Failed to fetch transactions');
            }
          } else {
            throw new Error('Failed to fetch transactions');
          }
        } else {
          const data = await response.json();
          if (Array.isArray(data)) {
            setTransactions(data);
          } else {
            throw new Error('Unexpected response format');
          }
        }

        setLoading(false);
      } catch (err) {
        setError(err.message); // Handle errors
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col w-full gap-4 p-4">
        <div className="font-bold text-[18px] text-center">Transactions</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {Array(6).fill(0).map((_, index) => (
            <div key={index} className="flex flex-col p-4 bg-slate-100 animate-pulse rounded-lg shadow-md">
              <div className="flex justify-between items-center">
                <div className="h-[20px] w-[70%] bg-gray-300 rounded"></div>
                <div className="h-[15px] w-[20%] bg-gray-300 rounded"></div>
              </div>
              <div className="h-[15px] mt-2 w-[50%] bg-gray-300 rounded"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return <div className="text-red-500 text-center">{error}</div>;
  }

  return (
    <div className="flex flex-col w-full gap-4 p-4">
      <div className="font-bold text-[18px] text-center">Transactions</div>
      {transactions.length === 0 ? (
        <div className="text-center text-gray-500">No transactions found.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {transactions.map((transaction) => (
            <div key={transaction.id} className="flex flex-col p-4 bg-white hover:bg-gray-50 rounded-lg shadow-md transition duration-300">
              <div className="flex justify-between items-center">
                <div className="text-sm text-gray-800 font-medium">
                  {transaction.amount} Uxbroot (UXB) | {selectedCurrency} {convertBalance(transaction.amount)} has been {transaction.type}ed {transaction.type === 'deposit' ? 'to' : 'from'} your account.
                </div>
                <div className="text-xs text-gray-400">{new Date(transaction.createdAt).toLocaleDateString()}</div>
              </div>
              <div className="text-xs text-gray-500 font-semibold mt-2">
                Transaction ID: {transaction.id}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Transacts;
